var isTouchDevice = 'ontouchstart' in document.documentElement;

// ��������� �������
initMetrika();

$(function () {
	if (isTouchDevice) {
		$('.touch_hidden').hide();
	}

	$(document).on('yacounter45775443inited', function () {
		$('body').on('click', 'a[data-banner_id]', function () {
			ym(45775443, 'reachGoal', 'banner_click', {URL: urlhelper.getCurrentUrl()});
		});
	});

	$('[data-toggle-disabled]').on('change', function () {
		var target = $(this).data('toggle-disabled');
		var button = $(target);
		var checked = $(this).prop('checked');
		button.prop('disabled', !checked);
	});
});

function format_price(e) {
	if (e.type && e.target) {
		var target = e.target || e.srcElement;
	} else {
		var target = e;
	}

	var cursorPos = get_cursor_position(target);
	if (cursorPos == -1) {
		cursorPos = 0;
	}

	var str = $(target).val();

	var fraction = str.match(/[.,].*$/);
	if (!fraction) {
		fraction = '';
	}
	str = str.replace(fraction, '');

	var new_str = '';
	var now = 0;
	for (var i = str.length - 1; i >= 0; i--) {
		var char = str.charAt(i);
		if (char == ' ' || !char.match(/^[0-9]$/)) {
			cursorPos--;
		} else {
			if (now < 3) {
				now++;
				new_str = char + new_str;
			} else {
				now = 1;
				cursorPos++;
				new_str = char + ' ' + new_str;
			}
		}
	}

	$(target).val(new_str + fraction);

	set_cursor_position(target, cursorPos);

	return true;
}


function get_cursor_position(inputEl) {
	if (document.selection && document.selection.createRange) {
		var range = document.selection.createRange().duplicate();
		if (range.parentElement() == inputEl) {
			range.moveStart('textedit', -1);
			return range.text.length;
		}
	} else if (inputEl.selectionEnd) {
		return inputEl.selectionEnd;
	} else
		return -1;
}


function set_cursor_position(inputEl, position) {
	if (inputEl.setSelectionRange) {
		inputEl.focus();
		inputEl.setSelectionRange(position, position);
	} else if (inputEl.createTextRange) {
		var range = inputEl.createTextRange();
		range.collapse(true);
		range.moveEnd('character', position);
		range.moveStart('character', position);
		range.select();
	}
}
